import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        margin: 10
    },
    title: {
        paddingTop: 20,
        paddingBottom: 20 ,
        textAlign : 'center'
    },
}))
